import { useState } from "react";

import isEqual from "lodash-es/isEqual";
import { useInterval } from "replo-utils/react/use-interval";

interface UseIntervalOptionsProps<T> {
  options: readonly T[];
  interval: number;
}

export function useIntervalOptions<T>({
  options,
  interval,
}: UseIntervalOptionsProps<T>): T | undefined {
  const [index, setIndex] = useState(0);
  const [prevOptions, setPrevOptions] = useState(options);

  if (!isEqual(prevOptions, options)) {
    setPrevOptions(options);
    setIndex(0);
  }

  useInterval(
    () => {
      setIndex((currentIndex) => (currentIndex + 1) % options.length);
    },
    options.length > 1 ? interval : null,
  );

  return options[index];
}
